// extracted by mini-css-extract-plugin
export default {"root":"bottom-navigation_root__WoiR2"};